
    document.addEventListener('DOMContentLoaded', function() {
        const slider = document.getElementById('imageSlider');
        const images = slider.querySelectorAll('.slider-image');
        let currentIndex = 0;
        const intervalTime = 5000; // 5 seconds
        
        function showNextImage() {
            // Hide current image
            images[currentIndex].style.display = 'none';
            
            // Move to next index
            currentIndex = (currentIndex + 1) % images.length;
            
            // Show next image
            images[currentIndex].style.display = 'block';
        }
        
        // Initial setup
        for (let i = 1; i < images.length; i++) {
            images[i].style.display = 'none';
        }
        
        // Start rotation
        setInterval(showNextImage, intervalTime);
    });
